import { RightOutlined } from '@ant-design/icons'
import React from 'react'

import {
  MenuRow,
  MenuRowWithArrow,
  ScrollColumn,
} from 'components/date-range-picker/CascadingDateMenu/styles'
import type {
  PriorPeriodEntry,
  PriorPeriodGroup,
} from 'components/date-range-picker/types'

// Column 2 content when "Prior Period" is hovered: the periodicity groups
// (Week/Month/Quarter/Half/Year). Split out of CascadingDateMenu.tsx to keep
// that file under the component-file-too-large warning threshold.
export const PriorPeriodGroupColumn: React.FC<{
  groups: readonly PriorPeriodGroup[]
  hoveredGroupKey: string | null
  selectedGroupKey: string | null
  onHoverGroup: (groupKey: string) => void
}> = ({ groups, hoveredGroupKey, selectedGroupKey, onHoverGroup }) => (
  <>
    {groups.map((group) => (
      <MenuRowWithArrow
        key={group.key}
        $selected={selectedGroupKey === group.key}
        $active={
          hoveredGroupKey === group.key || selectedGroupKey === group.key
        }
        onMouseEnter={() => onHoverGroup(group.key)}
      >
        {group.label}
        <RightOutlined />
      </MenuRowWithArrow>
    ))}
  </>
)

// Column 3 content: the named periods for the hovered group, newest-first.
export const PriorPeriodEntryColumn: React.FC<{
  entries: readonly PriorPeriodEntry[]
  selectedEntryKey: string | null
  onSelect: (entry: PriorPeriodEntry) => void
}> = ({ entries, selectedEntryKey, onSelect }) => (
  <ScrollColumn
    onMouseDown={(e) => e.stopPropagation()}
    onClick={(e) => e.stopPropagation()}
  >
    {entries.map((entry) => (
      <MenuRow
        key={entry.key}
        $selected={selectedEntryKey === entry.key}
        onClick={() => onSelect(entry)}
      >
        {entry.label}
      </MenuRow>
    ))}
  </ScrollColumn>
)
